type TFormat = 'DD.MM.YYYY' | 'DD.MM.YY' | 'HH:mm';

/**
 * Утилита для форматирования даты.
 *
 * @param {string} textDate - текстовое представление даты, понятное Date-конструктору.
 * @param {string} format - формат даты, которую нужно получить на выходе.
 * @returns {string} - результат форматирования.
 *
 * @example
 *
 * formatDate('2019-08-23T09:34:29.158Z', 'DD.MM.YYYY')
 *
 */

export const formatDate = (textDate: string, format: TFormat) => {
  const date = new Date(textDate);
  switch (format) {
    case 'DD.MM.YYYY': {
      return date.toLocaleDateString(['ru'], {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
      });
    }
    case 'DD.MM.YY': {
      return date.toLocaleDateString(['ru'], {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
      });
    }
    case 'HH:mm': {
      return date.toLocaleTimeString(['ru'], {
        hour: 'numeric',
        minute: 'numeric',
      });
    }
  }
};
